var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0081 3.76276L10.7029 1.48908C9.93476 1.15989 9.06528 1.15989 8.29716 1.48908L2.99191 3.76276C2.61766 3.92316 2.375 4.29115 2.375 4.69833V10.045C2.375 12.0174 3.32751 13.8683 4.93245 15.0146L8.31678 17.432C9.0246 17.9376 9.97545 17.9376 10.6833 17.432L14.0676 15.0146C15.6725 13.8683 16.625 12.0174 16.625 10.045V4.69833C16.625 4.29115 16.3824 3.92316 16.0081 3.76276ZM13.4807 7.82294C13.8904 7.31082 13.8074 6.56353 13.2952 6.15383C12.7831 5.74413 12.0358 5.82717 11.6261 6.33929L8.3835 10.3926L7.28593 9.29501C6.82219 8.83126 6.0703 8.83126 5.60655 9.29501C5.14281 9.75876 5.14281 10.5106 5.60655 10.9744L7.1732 12.541C7.92389 13.2917 9.16045 13.2232 9.82365 12.3942L13.4807 7.82294Z",
    fill: "#56B375"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.32f2e24e42b56cfd007b26872273524c.svg";
export { ForwardRef as ReactComponent };